import { FC, useRef, useState } from "react";

import { requestsRepository } from "../../../api/RequestsRepository";
import { CustomButton } from "../../CustomButton/CustomButton";
import { ModalComponent } from "../UiModals";
import { CancelIcon } from "../../icons/CacnelIcon";
import { ChatUser } from "../../../api/models/ChatUser";
import { useDetectOutsideClick } from "../../../hooks/useDetectOutsideClick";
import { SettingsIcon } from "../../icons/SettingsIcon";
import { ROBOT_ID } from "../../../api/models/consts";
import { UserPhoto } from "../../UserPhoto/UserPhoto";
import { env } from "../../../env";

interface IProps {
    users: ChatUser[];
    isAdmin: boolean;
    userId: string | null;
    chatId: string | null;
    changeChatAccess: (userId: string) => void;
    changeIsAdminAccess: (userId: string, isAdmin: boolean) => void;
    authSessionId?: string;
    isMobile?: boolean;
}

interface IPropsActions extends IProps {
    close: () => void;
}

const Modal: FC<IPropsActions> = ({
                                      close,
                                      users,
                                      userId,
                                      isAdmin,
                                      chatId,
                                      changeChatAccess,
                                      changeIsAdminAccess,
                                      authSessionId,
                                      isMobile = false
                                  }) => {

    const [showUserSettings, setShowUserSettings] = useState<any>(null);
    const [showDeleteUser, setShowDeleteUser] = useState<any>(null);

    const ref = useRef<HTMLDivElement | null>(null);

    useDetectOutsideClick(ref, () => setShowUserSettings(false));

    const onDeleteClick = (userId: string, chatId: string | null) => {
        requestsRepository.ChatApiService.changeReadAccess(userId, chatId).then((res) => {
            if (res.success) {
                changeChatAccess(userId);
                setShowDeleteUser(null);
            }
        })
    }

    const onMakeAdminClick = (userId: string, chatId: string | null, isAdmin: boolean) => {
        requestsRepository.ChatApiService.changeIsAdminAccess(userId, chatId, isAdmin).then((res) => {
            if (res.success) {
                changeIsAdminAccess(userId, isAdmin);
                setShowDeleteUser(null);
            }
        })
    }

    const onCancelDeleteClick = () => {
        setShowDeleteUser(null);
    }

    return (
        <div className={`communication-modal-container ${isMobile ? 'communication-modal-container_mobile' : ''}`}>
            <div className="communication-modal-content" style={{width: 600}}>
                <div className="communication-modal-title communication-modal-title_contacts">
                    <div className="communication-modal-title__text">Информация</div>
                </div>
                <div className="communication-modal-body communication-modal-body_contacts communication-modal-body_information">
                    <div className="communication-modal-content" style={{display: 'flex', flexDirection: 'column', gap: 12}}>
                        {users.filter(x => x.userId !== ROBOT_ID && x.canRead).map((user: any, key: number) =>
                            <div key={key} className="communication-modal-user-information">
                                <div className={'communication-modal-user-information-main'}>
                                    {authSessionId && authSessionId?.length > 0 && <UserPhoto sessionId={authSessionId} userId={user.userId}/>}
                                    <div className={'communication-modal-content-search-item-main-info'}>
                                        <div className={'communication-modal-content-search-item-main-info__title'}>{user.userName}{user.isAdmin && <span> <span style={{color: '#9EA0A3', fontWeight: 400, fontSize: 14}}>Администратор</span></span>}</div>
                                        <div
                                            className={'communication-modal-content-search-item-main-info__description'}>{user.description}</div>
                                    </div>
                                </div>
                                {isAdmin && userId !== user.userId && <SettingsIcon divClassName={"chat-settings-icon-container"} ref={ref} className="chat-settings" onClick={() => {
                                setShowUserSettings(user.userId)
                            }}>
                                <div style={{display: showUserSettings === user.userId ? 'flex' : 'none'}}
                                     className="message-box-settings-container">
                                    <div className="message-box-settings-item" onClick={() => {
                                        setShowUserSettings(null);
                                        setShowDeleteUser(user.userId);
                                    }}>Удалить участника</div>
                                    {env().REACT_APP_CHANGE_ACCESS &&
                                    <div className="message-box-settings-item" onClick={() => {
                                        setShowUserSettings(null);
                                        onMakeAdminClick(user.userId, chatId, !user.isAdmin);
                                    }}>{user.isAdmin ? 'Удалить права администратора' : 'Сделать администратором'}</div>}
                                </div>
                                <div style={{display: showDeleteUser === user.userId ? 'flex' : 'none'}}
                                     className="delete-message">
                                    <div className="delete-message__title">Удалить участника?</div>
                                    <div className="delete-message-btns-container">
                                        <div className="delete-btn" onClick={() => onDeleteClick(user.userId, chatId)}>Удалить</div>
                                        <div className="cancel-btn" onClick={onCancelDeleteClick}>Отменить</div>
                                    </div>
                                </div>
                            </SettingsIcon>}</div>)}
                    </div>
                </div>
            </div>
            <CustomButton
                onClick={close}
                isRound={true}
                outline={true}
            ><CancelIcon /></CustomButton>
        </div>
    );
};

export const UserInformation = (props: IProps): ModalComponent => {
    return ({close}) => {
        return <Modal close={close} {...props} />;
    };
};
